import { size, colors, Icons } from '@everlywell/leaves';
import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: ${size.sm}px ${size.md}px ${size.sm}px ${size.sm}px;
  background-color: ${colors.green1};
  display: flex;
`;

export const Icon = styled(Icons.Information)`
  color: ${colors.teal6};
`;

export const IconWrapper = styled.div`
  max-width: ${size.lg}px;
  margin-right: ${size.xs1}px;
`;
